<template>
  <div class="flex flex-col bg-gray-50 pb-2 p-4 items-center" v-if="isTicketCreated">
    <p class="text-md">{{ message }}</p>
  </div>
  <div class="scrollable-container" v-else>
    <header class="flex flex-col bg-gray-50 pb-2 px-4">
    <h3 class="text-md font-semibold mt-6">Create Ticket</h3>
  </header>
  <V3PageLoaderComponent text="Creating ticket..." v-if="isLoading"  />
  <section>
    <div class="flex flex-col bg-gray-50 pb-8 p-5 items-center">
      <UForm class="space-y-8 w-full py-2">
        <UFormGroup name="title">
          <UInput type="text" v-model="form.issueTitle" size="xl" placeholder="Ticket Title" />
          <p v-if="errors.issueTitle" class="text-red-500 text-sm mt-1">{{ errors.issueTitle }}</p>
        </UFormGroup>

        <!-- Category and Subcategory dropdowns -->
        <div class="flex space-x-4 w-full">
          <div class="basis-1/2">
            <USelect
              v-model="form.issueCategory"
              :options="categories"
              option-attribute="name"
              value-attribute="value"
              placeholder="Ticket category"
              size="xl"
            />
          </div>
          <div class="basis-1/2">
            <USelect
              v-model="form.issueSubCategory"
              :options="subCategoryList"
              option-attribute="name"
              value-attribute="value"
              placeholder="Sub category"
              size="xl"
            />
          </div>
        </div>

        <div class="flex space-x-4 w-full" v-if="errors.issueCategory || errors.issueSubCategory">
          <p v-if="errors.issueCategory" class="text-red-500 text-sm mt-1">{{ errors.issueCategory }}</p>
          <p v-if="errors.issueSubCategory" class="text-red-500 text-sm mt-1">{{ errors.issueSubCategory }}</p>
        </div>

        <!-- Choose Items Label -->
        <h3 class="text-md font-semibold mt-2">Choose items</h3>

        <!-- Product List -->
        <div class="space-y-4 w-full px-3">
          <div v-for="(product, index) in filterProducts" :key="product.id" class="flex items-center space-x-4">
            <!-- Product Checkbox -->
             <div class="inline-flex w-full gap-4 basis-auto">
                <div class="shrink-0">
                  <input
                    type="checkbox"
                    :id="'product' + index"
                    class="h-4 w-4"
                    v-model="product.selected"
                  />
                </div>
                <div class="grow-0 shrink-0 text-wrap break-all basis-2/6">
                  <label :for="'product' + index" class="text-md">{{ product.title }}</label>
                </div>
                <div class="grow-0 shrink-0 basis-1/6">
                  <span class="text-m">₹ {{ product.price.value }}</span>
                </div>
                <div class="grow-0 shrink-0 basis-2/6">
                  <div class="flex items-center space-x-2">
                    <button
                      class="px-2 py-1 border rounded"
                      @click="updateQuantity(product, -1)"
                      :disabled="product.quantity.count <= 1"
                    >
                      -
                    </button>
                    <span class="text-m">{{ product.quantity.count }}</span>
                    <button
                      class="px-2 py-1 border rounded"
                      @click="updateQuantity(product, 1)"
                      :disabled="product.quantity.count >= product.maxQuantity"
                    >
                      +
                    </button>
                  </div>
                </div>
             </div>
          </div>
          <p v-if="errors.products" class="text-red-500 text-sm mt-2">{{ errors.products }}</p>
        </div>

        <UFormGroup name="Description">
          <UTextarea
            rows="4"
            size="xl"
            v-model="form.issueDescription"
            placeholder="Ticket Description"
          />
          <p v-if="errors.issueDescription" class="text-red-500 text-sm mt-1">{{ errors.issueDescription }}</p>
        </UFormGroup>
      </UForm>
    </div>
  </section>

  <div class="flex justify-center items-center space-x-4 w-full mt-6">
    <UButton size="md" label="Submit" class="w-5/12 md:w-2/5" @click="validateAndRaiseIssue" />
  </div>
  </div>
  
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        orderId: this.data.order_id,
        issueTitle: "",
        issueCategory: "",
        issueSubCategory: "",
        products: [],
        issueDescription: "",
        image: "",
      },
      isLoading: false,
      errors: {},
      categories: [
        { name: "Item", value: "ITEM" },
        { name: "Fulfillment", value: "FULFILLMENT" },
      ],
      subCategories: [
        { name: "Missing items", value: "ITM01", parent: "ITEM" },
        { name: "Quantity issue", value: "ITM02", parent: "ITEM" },
        { name: "Item mismatch", value: "ITM03", parent: "ITEM" },
        { name: "Quality issue", value: "ITM04", parent: "ITEM" },
        { name: "Expired item", value: "ITM05", parent: "ITEM" },
        { name: "Delay in delivery", value: "FLM02", parent: "FULFILLMENT" },
        { name: "Delayed delivery", value: "FLM03", parent: "FULFILLMENT" },
        { name: "Packaging", value: "FLM04", parent: "FULFILLMENT" },
        { name: "Incorrectly marked as delivered", value: "FLM08", parent: "FULFILLMENT" },
      ],
      subCategoryList: [],
      provider:[],
      seller:[],
      isLoading:false,
      isTicketCreated:false,
      message:""
    };
  },
  watch: {
    'form.issueCategory': {
      handler(newValue) {
        this.subCategoryList = this.subCategories.filter((k) => k.parent === newValue.toUpperCase());
        this.form.issueSubCategory = '';
      },
      deep: true,
    },
  },
  computed: {
    filterProducts() {
      const result = [];
      const fulfillment_id = this.data.message.order.fulfillments.find((data) => {
        return data.type.toLowerCase() === 'delivery';
      })?.id;

      const products = this.data.message.order.quote.breakup.filter(
        (k) => k['@ondc/org/title_type'].toLowerCase() === 'item'
      );

      const completed = [];

      for (const item of products) {
        if (!completed.includes(item['@ondc/org/item_id'])) {
          const oitems = this.data.message.order.items.filter(
            (k) =>
              k.id.toString() === item['@ondc/org/item_id'].toString() &&
              k.fulfillment_id === fulfillment_id
          );

          for (const k of oitems) {
            result.push({
              ...item,
              ...k,
              selected: false, // Add a "selected" property to handle checkbox state
            });
          }

          completed.push(item['@ondc/org/item_id']);
        }
      }

      return result;
    },
  },
  methods: {
    // Validate the form before submission
    validateForm() {
      this.errors = {}; // Reset errors
      let isValid = true;

      // Validate required fields
      if (!this.form.issueTitle) {
        this.errors.issueTitle = "Please enter an issue title.";
        isValid = false;
      }
      if (this.form.issueCategory === "") {
        this.errors.issueCategory = "Please choose an issue category.";
        isValid = false;
      }
      if (this.form.issueSubCategory === "") {
        this.errors.issueSubCategory = "Please choose a subcategory.";
        isValid = false;
      }

      // Validate that at least one product is selected
      const selectedProducts = this.filterProducts.filter((product) => product.selected);
      if (selectedProducts.length === 0) {
        this.errors.products = "Please choose at least one product.";
        isValid = false;
      }

      // Validate description
      if (!this.form.issueDescription) {
        this.errors.issueDescription = "Please provide a description of the issue.";
        isValid = false;
      }

      return isValid;
    },

    // Call this method before raising the ticket
    validateAndRaiseIssue() {
      if (this.validateForm()) {
        // Prepare the payload for API call
        console.log("filtered products::",this.filterProducts)
        const selectedProducts = this.filterProducts
          .filter((product) => product.selected)
          .map((product) =>  ({
              id: product.id,  
              name: product.title, 
              quantity: {
                count: product.quantity.count
              }
            }));

        const payload = {
          title: this.form.issueTitle,
          category: this.form.issueCategory,
          sub_category: this.form.issueSubCategory,
          description: this.form.issueDescription,
          products: selectedProducts,
          files: this.form.image ? [this.form.image] : [], // Include image if available
          provider:this.data.provider,
          seller:this.data.seller
        };

        // If form is valid, proceed to raise the issue
        this.raiseIssue(payload);
      }
    },
    resetIssueDetails()
    {
      this.form =  {
        orderId: this.data.order_id,
        issueTitle: "",
        issueCategory: "Choose issue category",
        issueSubCategory: "Choose sub category",
        products: [],
        issueDescription: "",
        image: "",
      }
    },

    async raiseIssue(payload) {
      this.isLoading = true
      console.log("payload data check 1:::",payload)
      const formData = new FormData();
      formData.append('order_id', this.data.order_id);
      formData.append('title', payload.title);
      formData.append('category', payload.category);
      formData.append('sub_category', payload.sub_category);
      formData.append('description', payload.description);
      formData.append('provider', JSON.stringify(payload.provider));
      formData.append('seller', JSON.stringify(payload.seller));

      // Adding products
      if (payload.products.length > 0) {
        formData.append('products', JSON.stringify(payload.products));
      }

      // Adding files (images)
      if (payload.files.length > 0) {
        for (const file of payload.files) {
          formData.append('files', file);
        }
      }

      console.log("payload data check2::",formData)

      try {
        const response = await useAPIHandler('post','/tickets', {
          body: formData,
          headers: {},
          auth: true
        });
        this.resetIssueDetails()
        this.isLoading= false
        this.isTicketCreated = true
        this.message="Ticket created successfully..!\nYou can view the issue details in quick menu under 'My tickets'"
        console.log("response data of ticket api:::",response)
      } catch (err) {
        console.log(err);
         this.message="Unable to create Issue..!"
        this.isLoading= false

      }
    },
    updateQuantity(product, change) {
      const products = this.data.message.order.quote.breakup.filter(
        (k) => k['@ondc/org/title_type'].toLowerCase() === 'item'
      );
      for(const item of products)
      {
            if(product.id === item["@ondc/org/item_id"])
          {
              product.maxQuantity = item["@ondc/org/item_quantity"].count    
          }
      }
      const newQuantity = product.quantity.count + change;
      if (newQuantity >= 1 && newQuantity <= product.maxQuantity) {
        product.quantity.count = newQuantity;
      }
    },
  },
};
</script>

<style scoped>
/* Adjusting margin for error messages */
.mt-1 {
  margin-top: 0.25rem;
}

/* Scrollable container with a fixed height */
.scrollable-container {
  overflow-y: auto; /* Enable vertical scrolling */
  max-height: calc(100vh - 180px); /* Set the max height relative to viewport height */
  padding-right: 8px; /* Optional: Adds padding for the scrollbar */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling for iOS */
}
 
/* Ensure that scrolling is smooth */
.scrollable-container::-webkit-scrollbar {
  width: 6px;
}
.scrollable-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
.scrollable-container::-webkit-scrollbar-track {
  background: transparent;
}
 
/* Mobile-specific adjustment for scrollable area */
@media (max-width: 768px) {
  .scrollable-container {
    max-height: calc(100vh - 150px); /* Adjust for smaller screens */
  }
}
</style>
